import { Collection } from 'modules/core/lib/mobx-rest'
import createCollectionContext from 'modules/core/store/collections/CollectionContext'

import OvertimeCompensation from 'modules/attendance/store/models/TimeoffCompensation'

class TimeoffCompensations extends Collection<OvertimeCompensation> {
  get cacheKey(): string {
    return 'timeoffCompensations'
  }

  model() {
    return OvertimeCompensation
  }

  get indexes() {
    return ['attendance_employees_setting_id', 'attendance_employees_policy_id']
  }
}

const timeoffCompensations = new TimeoffCompensations()

export default timeoffCompensations

const { provider: TimeoffCompensationsProvider, hook: useTimeoffCompensations } =
  createCollectionContext<OvertimeCompensation, TimeoffCompensations>()

export { TimeoffCompensationsProvider, useTimeoffCompensations }
